import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { Link } from "react-router-dom";
import { OrderWithPrescription } from "src/api/types";
import { columns } from "../../utils/columns";
import OrderStatusChip from "src/components/OrderStatusChip";
import { Checkbox, Typography } from "@mui/material";
import { useCallback, useMemo } from "react";
import BillingModel from "src/components/BillingModel";
import { useSelection } from "src/context/ItemsSelectionProvider/useSelection";
import { Paths } from "src/constants/paths";
import InvoiceStatusChip from "src/components/InvoiceStatusChip";

interface Props {
  row: OrderWithPrescription;
}

const OrdersTableRow = ({ row }: Props) => {
  const { selected, setSelected } = useSelection();

  const isSelected = useMemo(() => {
    return selected.includes(row.id);
  }, [selected, row.id]);

  const handleSelect = useCallback(() => {
    setSelected(
      selected.includes(row.id)
        ? selected.filter((id) => id !== row.id)
        : [...selected, row.id],
    );
  }, [row.id, selected, setSelected]);

  return (
    <TableRow hover role="checkbox" tabIndex={-1}>
      <TableCell padding="none">
        <Checkbox
          color="primary"
          aria-label="select task"
          onChange={handleSelect}
          checked={isSelected}
        />
      </TableCell>
      {columns.map((column) => {
        return (
          <TableCell key={column.id} align={column.align}>
            {column.id === "patient_id" ? (
              <Link
                to={`${Paths.DASHBOARD_PATIENTS}/${row.patient_id}`}
                target="_blank"
              >
                {row[column.id]}
              </Link>
            ) : column.id === "status" ? (
              <OrderStatusChip
                status={row.status}
                flag={row.is_delayed ? "Delayed" : undefined}
              />
            ) : column.id === "billing_model" ? (
              <BillingModel model={row.product.billing_model} />
            ) : column.id === "invoice_status" ? (
              <InvoiceStatusChip invoiceId={row.invoice_id} />
            ) : column.format ? (
              <Typography>{column.format(row)}</Typography>
            ) : (
              <Typography>N/A</Typography>
            )}
          </TableCell>
        );
      })}
    </TableRow>
  );
};

export default OrdersTableRow;
